<template>
  <div>
    <div v-if="!base64File">
      <div
        class="b"
        @drop.prevent="dropFile"
        @dragenter.prevent
        @dragover.prevent
      >
        <div class="mt-5">
          Drag and drop
        </div>
      </div>

      <div class="has-text-centered w-100" style="text-align:center;width:100%">
        <b-button
          type="is-primary is-light"
          size="sm"
          class="pl-4 pr-4"
          style="margin-top:-25px"
          @click.prevent="upload"
          >Upload Image</b-button
        >
      </div>
      <input
        type="file"
        style="display:none"
        ref="fileupload"
        accept="*/image"
        @change="fileManuallyUploaded"
      />
    </div>
    <div v-else>
      <img
        :src="base64File"
        :style="'width: ' + this.internalWidth + 'px'"
      /><br />
      <div class="pt-5">
        <b-button
          type="is-primary is-light"
          size="sm"
          class="pl-4 pr-4"
          style="margin-top:-25px"
          @click.prevent="cancel"
          >Remove</b-button
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "upload-image",
  props: { imageUrl: null, width: null },
  data() {
    return {
      internalWidth: null,
      file: null,
      base64File: null,
    };
  },

  watch: {
    width() {
      this.internalWidth = this.width;
    },
  },
  computed: {
    uploadDisabled() {
      return this.files.length === 0;
    },
  },
  created() {
    if (this.imageUrl) this.base64File = this.imageUrl;
    this.internalWidth = this.width;
  },
  methods: {
    fileManuallyUploaded(e) {
      this.generateBase64File(e.target.files[0]);
    },
    cancel() {
      this.base64File = null;
      this.$emit("url", null);
    },
    upload() {
      this.$refs.fileupload.click();
    },
    dropFile(e) {
      if (e.dataTransfer.files.length > 1) {
        this.$emitter.emit("error", "You can only drag 1 file.");
        return;
      }
      this.generateBase64File(e.dataTransfer.files[0]);
    },
    async generateBase64File(file) {
      let formData = new FormData();
      formData.append("file", file);

      let r = await this.$client.post("/api/system/uploadBlob", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      this.$emit("url", r.data.fileURL);

      const reader = new FileReader();
      reader.onloadend = () => {
        this.base64File = reader.result;
      };
      reader.readAsDataURL(file);
    },
  },
};
</script>

<style scoped>
.b {
  border: dashed 5px #efefef;
  height: 140px;
  text-align: center;
}
</style>
